import { AppLayout } from "core";
import React from "react";
import { ReactComponent as MyList } from "src/assets/dist/ic_collection.svg";
import { ReactComponent as Home } from "src/assets/dist/ic_home.svg";
import { ReactComponent as BnPlus } from "src/assets/dist/ic_blacknut_plus.svg";
import { ReactComponent as Search } from "src/assets/dist/ic_search.svg";
import AccountLink from "../../AccountNavLink";
import NavLink from "../../NavLink";
import styles from "../styles.module.scss";
import { ReactComponent as LeMag } from "src/assets/dist/ic_lemag.svg";
import { UserProfile } from "@blacknut/javascript-sdk/dist";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
export interface NavsLinksProps {
  layout: AppLayout;
  pathname: string;
  activeItem: string;
  profile: UserProfile | undefined;
  blacknutPlus: boolean;
  lemag: boolean;
  className?: string;
  expanded: boolean;
}

const NavsLinks = ({
  layout,
  pathname,
  activeItem,
  lemag,
  profile,
  blacknutPlus,
  className,
  expanded,
}: NavsLinksProps) => {
  const { t } = useTranslation();
  return (
    <div
      className={clsx(
        className,
        layout == AppLayout.TV ? styles.isOnTv : styles.container,
      )}
    >
      <div className={clsx(styles.wrap, expanded && styles.expanded)}>
        <NavLink
          to="/catalog"
          replace={pathname === "/catalog"}
          isActive={() => activeItem === "catalog"}
          data-testid="catalog"
          className={styles.marginIcon}
        >
          <Home className="svg" />
          <span className={clsx(styles.label, !expanded && styles.hidden)}>
            {t("menu.catalog")}
          </span>
        </NavLink>

        {blacknutPlus && (
          <NavLink
            to="/plus"
            replace={pathname === "/plus"}
            isActive={() => activeItem === "plus"}
            className={styles.marginIcon}
          >
            <BnPlus className="svg" />
            <span className={clsx(styles.label, !expanded && styles.hidden)}>
              {t("menu.plus")}
            </span>
          </NavLink>
        )}

        {lemag && !blacknutPlus && (
          <NavLink
            to="/lemag"
            replace={pathname === "/lemag"}
            isActive={() => activeItem === "lemag"}
            data-testid="lemag"
            className={styles.marginIcon}
          >
            <LeMag className="svg" />
            <span className={clsx(styles.label, !expanded && styles.hidden)}>
              {t("menu.lemag")}
            </span>
          </NavLink>
        )}

        <NavLink
          replace={pathname === "/myList"}
          to="/myList"
          isActive={() => activeItem === "myList"}
          data-testid="myList"
          requiresAnonymousCheck={true}
          className={styles.marginIcon}
        >
          <MyList className="svg" />
          <span className={clsx(styles.label, !expanded && styles.hidden)}>
            {t("menu.mylist")}
          </span>
        </NavLink>

        <NavLink
          to="/search"
          replace={pathname === "/search"}
          isActive={() => activeItem === "search"}
          data-testid="search"
          className={styles.marginIcon}
        >
          <Search className="svg" />
          <span className={clsx(styles.label, !expanded && styles.hidden)}>
            {t("menu.search")}
          </span>
        </NavLink>

        {profile && (
          <AccountLink activeItem={activeItem} profile={profile} expanded={expanded} />
        )}
      </div>
    </div>
  );
};

export default NavsLinks;
